import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppraisalProvider } from "@/components/AppraisalContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import PropertyManagement from "@/pages/PropertyManagement";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <AppraisalProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/property-management" element={<PropertyManagement />} />
            <Route path="/home-owners" element={<Navigate to="/property-management" replace />} />
            <Route path="/tenants" element={<Navigate to="/property-management" replace />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </AppraisalProvider>
    </BrowserRouter>
  );
}

export default App;
